export default __webpack_public_path__ + "c3495c8300da8493d114a0bf14bf257e.png";